import { render } from "./faq-list.vue?vue&type=template&id=f57096a8&scoped=true"
import script from "./faq-list.vue?vue&type=script&lang=js"
export * from "./faq-list.vue?vue&type=script&lang=js"

import "./faq-list.vue?vue&type=style&index=0&id=f57096a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f57096a8"]])

export default __exports__